import _ from 'underscore';
import { getMessageForErrorCodeFn } from './get-message-for-code';
import { odataErrorHandler, ccErrorHandler } from './error-handlers';
import { ERROR_MESSAGES } from './error-messages';
import {
  I18nModel, IInstrumentation, IErrorMessages, GetMessageForErrorCodeFn, IErrorHandlerResult,
} from './types';

// server error code is not unique for now, so we temporarily depend on server error messages
// when MT fixed this error code issue, we should not use server error message any more
export const getErrorFromRaw = (
  i18n: I18nModel,
  instrumentation: IInstrumentation,
  errorMap: IErrorMessages,
  rawError: unknown,
  entity: string,
  field: string,
  useServerErrorMessage: boolean = false,
): IErrorHandlerResult => {
  // @ts-ignore
  const errorMapper: GetMessageForErrorCodeFn = getMessageForErrorCodeFn(i18n, instrumentation, errorMap);
  if (_.isObject(rawError)) {
    if (_.isNumber(rawError.ResultType)) {
      return ccErrorHandler(rawError as any, entity, field, errorMapper as any);
    }
  }
  return odataErrorHandler(rawError as any, entity, field, errorMapper as any, useServerErrorMessage);
};

export const getErrorFromRawFn = (i18n: I18nModel, instrumentation?: IInstrumentation, errorMap = ERROR_MESSAGES) =>
  // @ts-ignore
  (...args) => getErrorFromRaw(i18n, instrumentation, errorMap as any, ...args);
